import { CreateAccountRequest } from '../api/createaccount/createaccountrequest';
import { CreateAccountResponse, CreateAccountResponseDtoImpl } from '../api/createaccount/createaccountresponse';
import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { StatusCodes } from '../util/statuscodes';
import { APIFeatures } from '../util/apifeatures';
import { CreateAccountBuilder } from '../dto/createaccount/createaccountbuilder';
import { Strings } from '../../utils/resources/strings';

import { APIProcessorImpl } from './apiProcessor';

export class CreateAccountAPIProcessorImpl extends APIProcessorImpl<CreateAccountRequest, CreateAccountResponse>
{

    execute(request: CreateAccountRequest): void
    {
        super.execute(request);
    }
     /*  execute()
     {
         console.log("execute() in CreateAccountAPIProcessorImpl"); 

         let createAccountResponse = new CreateAccountResponseDtoImpl(APIFeatures.CREATE_ACCOUNT, "Account Created Successully");
         createAccountResponse.setRespDesc("Success");
         createAccountResponse.setClientTxnId("15042020");
         createAccountResponse.setTxnId("16042020");
         createAccountResponse.setSrvType("SRVType");
         createAccountResponse.setMsisdn("999999");
         createAccountResponse.setSecToc("12345");
             
         this.getAPISuccess(createAccountResponse);
     }  */

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try{
            
            if(+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
            {
                console.log("----status: " + responseMapper.getStatusCodeOutside());
                if(responseMapper.getStatusCodeOutside() === "SC0000" ||
                responseMapper.getResponseMap().respCode === "000" 
                            || responseMapper.getResponseMap().respCode === "SC0000")
                {
                    let response = new CreateAccountResponseDtoImpl(
                    APIFeatures.CREATE_ACCOUNT, this.getContext().getResources().getString(Strings.valid_subscriber));
                    let createAccountDetails = new CreateAccountBuilder(responseMapper.getResponseMap()).buildAll();
                    response.setCreateAccountDetails(createAccountDetails);
                         
                    this.getAPISuccess(response);
                }
                else if(responseMapper.getResponseMap().respCode === "100")
                {//non-registered etisalath
                    let response = new CreateAccountResponseDtoImpl(
                    APIFeatures.CREATE_ACCOUNT, this.getContext().getResources().getString(Strings.subscriber_not_registered));
    
                    this.getAPIFailure(response);
                }
                else if(responseMapper.getResponseMap().respCode === "002")
                {//password expired/ blocked by admin
                    let response = new CreateAccountResponseDtoImpl(
                    APIFeatures.CREATE_ACCOUNT, this.getContext().getResources().getString(Strings.password_blocked));
    
                    this.getAPIFailure(response);
                }
                else
                {
                    //not -registered, not-etisalath
                    let response = new CreateAccountResponseDtoImpl(
                        APIFeatures.CREATE_ACCOUNT, this.getContext().getResources().getString(Strings.invalid_mpt_subscriber));
        
                        this.getAPIFailure(response);
                }
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new CreateAccountResponseDtoImpl(APIFeatures.CREATE_ACCOUNT, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch(e)
        {
            console.log(e);
            this.getAPIFailure(new CreateAccountResponseDtoImpl(APIFeatures.CREATE_ACCOUNT, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        console.log("-----data.message: " + responseMapper.getStatusMsg());
                this.getAPIFailure(new CreateAccountResponseDtoImpl(APIFeatures.CREATE_ACCOUNT, responseMapper.getStatusMsg()));
            
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/createaccountapiprocessor.tsx